@if (parentFormGroup) {
  <div class="main-div align-items-center">
    <mat-form-field
      [ngClass]="!!currentConfig.isMultiSelect ? 'multi-select' : ''"
      [formGroup]="parentFormGroup"
      [floatLabel]="
        currentConfig?.tooltipConfig?.tooltipDesc ? 'always' : 'auto'
      "
    >
      <ng-template
        raMatLabelTooltip
        [tooltipConfig]="currentConfig?.tooltipConfig"
      ></ng-template>
      <mat-label [title]="currentConfig.displayText || ''">
        {{ currentConfig.displayText }}
      </mat-label>
      <!-- @for re-creates mat-select when isMultiSelect flips; mat-select
           throws if [multiple] changes after init. -->
      @for (isMulti of [!!currentConfig.isMultiSelect]; track isMulti) {
        <mat-select
          #matSelect
          [disableOptionCentering]="
            currentConfig.disableOptionCentering ?? true
          "
          [panelWidth]="currentConfig?.panelWidth ?? null"
          [panelClass]="
            'ra-dropdown-wide-panel mat-select-panel' +
            (currentConfig?.panelClass ? ' ' + currentConfig.panelClass : '')
          "
          [title]="getSelectedValueTitle(parentFormGroup, currentConfig)"
          [compareWith]="compareWithFn"
          [formControlName]="currentConfig.property"
          (opened)="onDropdownOpened(currentConfig)"
          [multiple]="isMulti"
          (selectionChange)="onValueChanged(selectedValues)"
          [disabled]="currentConfig?.orderOnly || currentConfig?.readOnly"
          [ngClass]="{
            'read-only':
              readOnly || currentConfig?.orderOnly || currentConfig?.readOnly,
          }"
        >
          <mat-select-trigger>
            @if (showSpinner) {
              <mat-spinner [diameter]="25"></mat-spinner>
            } @else {
              <div class="selected-values">
                @for (
                  value of getSelectedValueTitle(
                    parentFormGroup,
                    currentConfig
                  );
                  track value
                ) {
                  <span class="selected-value">{{ value }}</span>
                }
              </div>
            }
          </mat-select-trigger>
          <mat-option>
            <ngx-mat-select-search
              placeholderLabel="Search..."
              noEntriesFoundLabel="No search results"
              [formControl]="filterCtrl"
            ></ngx-mat-select-search>
          </mat-option>
          @if (currentConfig.loading) {
            <mat-option class="dropdown-loading pointer-events-none">
              <mat-spinner [diameter]="25"></mat-spinner>
            </mat-option>
          }
          @if (
            !!!currentConfig.isMultiSelect &&
            !readOnly &&
            !currentConfig.avoidNone
          ) {
            <mat-option>None</mat-option>
          }
          @if (!!!currentConfig.isGrouped) {
            @for (value of currentConfig.optionsToShow; track value) {
              <mat-option
                [disabled]="readOnly || isOptionDisabled(value)"
                [class.ra-has-disabled-hint]="
                  currentConfig.disabledValueHint && isOptionDisabled(value)
                "
                [value]="
                  currentConfig.dropdownID
                    ? value[currentConfig.dropdownID]
                    : !currentConfig.optionDisplayFields ||
                        currentConfig.optionDisplayFields.length === 0
                      ? value
                      : value[currentConfig.optionDisplayFields[0]]
                "
              >
                <span class="ra-option-content">
                  @if (!!!currentConfig.optionDisplayFields) {
                    <span>{{
                      currentConfig.dropdownLabel
                        ? value[currentConfig.dropdownLabel]
                        : value
                    }}</span>
                  } @else {
                    <div class="d-flex flex-column">
                      @for (
                        subTxt of currentConfig.optionDisplayFields;
                        track subTxt;
                        let i = $index
                      ) {
                        <span [ngClass]="'sub-text-' + i">{{
                          value[subTxt]
                        }}</span>
                      }
                    </div>
                  }
                  @if (
                    currentConfig.disabledValueHint && isOptionDisabled(value)
                  ) {
                    <span class="ra-option-disabled-hint">{{
                      currentConfig.disabledValueHint
                    }}</span>
                  }
                </span>
              </mat-option>
            }
          } @else {
            @for (group of currentConfig.optionsToShow; track group) {
              <mat-optgroup
                [label]="group.label | titlecase"
                [disabled]="readOnly"
              >
                @for (option of group.options; track option) {
                  <mat-option
                    [disabled]="isOptionDisabled(option)"
                    [value]="
                      !currentConfig.optionDisplayFields ||
                      currentConfig.optionDisplayFields.length === 0
                        ? option
                        : currentConfig.optionDisplayFields.length > 1 &&
                            option[currentConfig.optionDisplayFields[1]] !==
                              null &&
                            option[currentConfig.optionDisplayFields[1]] !==
                              undefined
                          ? option[currentConfig.optionDisplayFields[0]] +
                            ' (' +
                            option[currentConfig.optionDisplayFields[1]] +
                            ')'
                          : option[currentConfig.optionDisplayFields[0]]
                    "
                  >
                    @if (!!!currentConfig.optionDisplayFields) {
                      {{ option }}
                    } @else {
                      <div class="d-flex flex-column">
                        @for (
                          subTxt of currentConfig.optionDisplayFields;
                          track subTxt;
                          let i = $index
                        ) {
                          <span [ngClass]="'sub-text-' + i">{{
                            option[subTxt]
                          }}</span>
                        }
                      </div>
                    }
                  </mat-option>
                }
              </mat-optgroup>
            }
          }
          @for (
            val of currentConfig.isMultiSelect
              ? parentFormGroup
                  ?.get(currentConfig.property)
                  ?.value?.slice()
                  ?.sort(compareValues)
              : [parentFormGroup?.get(currentConfig.property)?.value];
            track val
          ) {
            <mat-option style="height: 0; display: none" [value]="val">
              {{ val }}
            </mat-option>
          }
        </mat-select>
      }
      <mat-hint [align]="currentConfig.hintAlignment">
        {{ currentConfig.hintLabel }}
      </mat-hint>
      @if (keys(parentFormGroup?.get(currentConfig.property)?.errors)?.length) {
        <mat-error>
          {{
            parentFormGroup.get(currentConfig.property).errors[
              keys(parentFormGroup.get(currentConfig.property).errors)[0]
            ]?.length
              ? parentFormGroup.get(currentConfig.property)?.errors[
                  keys(parentFormGroup.get(currentConfig.property)?.errors)[0]
                ]
              : currentConfig?.parentErrorMessages?.errors[
                  keys(parentFormGroup?.get(currentConfig.property)?.errors)[0]
                ] || "Please review the field"
          }}
        </mat-error>
      }
    </mat-form-field>
    @if (currentConfig?.viewData || currentConfig?.order) {
      <div class="d-flex ms-3 me-3 gap-2" style="margin-top: 18px">
        @if (
          currentConfig?.viewData &&
          parentFormGroup?.get(currentConfig.property)?.value
        ) {
          <i class="fas fa-eye" (click)="onViewClick()"></i>
        }
        @if (
          !readOnly &&
          currentConfig?.order &&
          currentConfig?.isMultiSelect &&
          parentFormGroup?.get(currentConfig.property)?.value?.length > 1
        ) {
          <i
            class="fa fa-sort cursor-pointer"
            (click)="toggleDragDropControl()"
          ></i>
        }
      </div>
    }
  </div>
}
